import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages';
import Terms from './components/Terms/Terms.js';
import ServicesPage from './pages/ServicesPage'; 
import Fernwartung from './components/Fernwartung/Fernwartung';

const App = () => {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/fernwartung" element={<Fernwartung />} />
        </Routes>
      </>
    </Router>
  );
};

export default App;
